import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import { Layout } from './components/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { InstallPrompt } from './components/InstallPrompt';

import { Landing } from './pages/Landing';
import { Signup } from './pages/Signup';
import { Login } from './pages/Login';
import { Overview } from './pages/Overview';
import { Clients } from './pages/Clients';
import { Issues } from './pages/Issues';
import { ScanTruck } from './pages/ScanTruck';
import { Receptions } from './pages/Receptions';
import { Losses } from './pages/Losses';
import { Inventories } from './pages/Inventories';
import { Hygiene } from './pages/Hygiene';
import { Movements } from './pages/Movements';
import { Alerts } from './pages/Alerts';
import { Reports } from './pages/Reports';
import { ImportMarjane } from './pages/Import';
import { Invoices } from './pages/Invoices';
import { Connectors } from './pages/Connectors';
import { Users } from './pages/Users';
import { Config } from './pages/Config';
import { Legal } from './pages/Legal';
import { Sync } from './pages/Sync';
import { MyStock } from './pages/MyStock';
import { Guide } from './pages/Guide';

function HomeRedirect() {
  const { isClientOwnerOnly } = useAuth();
  return <Navigate to={isClientOwnerOnly ? 'my-stock' : 'overview'} replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <ToastProvider>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/:tenantId/login" element={<Login />} />
            <Route path="/:tenantId" element={<Layout />}>
              <Route index element={<HomeRedirect />} />
              <Route path="my-stock" element={<MyStock />} />
              <Route path="guide" element={<Guide />} />
              <Route path="overview" element={<ProtectedRoute scopes={['read']}><Overview /></ProtectedRoute>} />
              <Route path="clients" element={<ProtectedRoute scopes={['read']}><Clients /></ProtectedRoute>} />
              <Route path="alerts" element={<ProtectedRoute scopes={['read']}><Alerts /></ProtectedRoute>} />
              <Route path="reports" element={<ProtectedRoute scopes={['read']}><Reports /></ProtectedRoute>} />
              <Route path="issues" element={<ProtectedRoute scopes={['issue']}><Issues /></ProtectedRoute>} />
              <Route path="scantruck" element={<ProtectedRoute scopes={['write']}><ScanTruck /></ProtectedRoute>} />
              <Route path="receptions" element={<ProtectedRoute scopes={['write']}><Receptions /></ProtectedRoute>} />
              <Route path="losses" element={<ProtectedRoute scopes={['write']}><Losses /></ProtectedRoute>} />
              <Route path="inventories" element={<ProtectedRoute scopes={['read']}><Inventories /></ProtectedRoute>} />
              <Route path="hygiene" element={<ProtectedRoute scopes={['hygiene']}><Hygiene /></ProtectedRoute>} />
              <Route path="movements" element={<ProtectedRoute scopes={['read']}><Movements /></ProtectedRoute>} />
              <Route path="import" element={<ProtectedRoute scopes={['import']}><ImportMarjane /></ProtectedRoute>} />
              <Route path="invoices" element={<ProtectedRoute scopes={['billing']}><Invoices /></ProtectedRoute>} />
              <Route path="comptapro" element={<ProtectedRoute scopes={['admin']}><Connectors /></ProtectedRoute>} />
              <Route path="users" element={<ProtectedRoute scopes={['admin']}><Users /></ProtectedRoute>} />
              <Route path="config" element={<ProtectedRoute scopes={['admin']}><Config /></ProtectedRoute>} />
              <Route path="legal" element={<ProtectedRoute scopes={['admin']}><Legal /></ProtectedRoute>} />
              <Route path="sync" element={<ProtectedRoute scopes={['read']}><Sync /></ProtectedRoute>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <InstallPrompt />
        </AuthProvider>
      </ToastProvider>
    </BrowserRouter>
  );
}
